export default __webpack_public_path__ + "static/media/JM.7fe77c51.svg";